import _ from "lodash";

export const emptyOrBlank = (x: any): boolean => {
  return (
    _.isNil(x) ||
    (_.isObjectLike(x) && _.isEmpty(x)) ||
    (_.isArrayLike(x) && _.isEmpty(x))
  );
};
